export default __webpack_public_path__ + "735e7f7f63a4a250b448bceb34cd69f2.png";